import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
// Styles are imported globally via styles/index.css

function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <Result
        status="404"
        title="404"
        subTitle="Spiacenti, la pagina che hai visitato non esiste."
        extra={
          <div className="button-group">
            <Button 
              type="primary" 
              onClick={() => navigate(-1)} 
              className="back-button"
            >
              Torna indietro
            </Button>
            <Button 
              onClick={() => navigate('/')}
              className="home-button"
            >
              Vai alla Home
            </Button>
          </div>
        }
      />
    </div>
  );
}

export default PageNotFound;